import React from "react";
import "./otpvalidation.css";
import EmaillSentInput from "./EmaillSentInput";
import OtpValidationInput from "./OtpValidation";

import { motion } from "motion/react";
import { useOtpSTatus } from "../../../context/OtpContext";
import OverlayTransition from "../../../common/animations/pageTransition/OverlayTransition";
import ZoomTransition from "../../../common/animations/pageTransition/ZoomTransition";
import bglogin from "../../../assest/images/bglogin.png";

const EmailVerify = () => {
  const { otpStatus, setOtpStatus } = useOtpSTatus();
  return (
    <div className="email-validatinbox">
      <div className="email-inside-box top-design">
        <div className="otp-verfiy-bg">
          {/* <svg
            id="wave"
            style={{ transform: "rotate(180deg)", transition: "0.3s" }}
            viewBox="0 0 1440 490"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
                <stop stop-color="rgba(243, 106, 62, 1)" offset="0%"></stop>
                <stop stop-color="rgba(255, 179, 11, 1)" offset="100%"></stop>
              </linearGradient>
            </defs>
            <path
              style={{ transform: "translate(0, 0px)", opacity: 1 }}
              fill="url(#sw-gradient-0)"
              d="M0,0L60,24.5C120,49,240,98,360,138.8C480,180,600,212,720,196C840,180,960,114,1080,114.3C1200,114,1320,180,1440,236.8C1560,294,1680,343,1800,310.3C1920,278,2040,163,2160,122.5C2280,82,2400,114,2520,138.8C2640,163,2760,180,2880,163.3C3000,147,3120,98,3240,138.8C3360,180,3480,310,3600,351.2C3720,392,3840,343,3960,269.5C4080,196,4200,98,4320,65.3C4440,33,4560,65,4680,98C4800,131,4920,163,5040,187.8C5160,212,5280,229,5400,269.5C5520,310,5640,376,5760,392C5880,408,6000,376,6120,302.2C6240,229,6360,114,6480,81.7C6600,49,6720,98,6840,114.3C6960,131,7080,114,7200,98C7320,82,7440,65,7560,98C7680,131,7800,212,7920,212.3C8040,212,8160,131,8280,122.5C8400,114,8520,180,8580,212.3L8640,245L8640,490L8580,490C8520,490,8400,490,8280,490C8160,490,8040,490,7920,490C7800,490,7680,490,7560,490C7440,490,7320,490,7200,490C7080,490,6960,490,6840,490C6720,490,6600,490,6480,490C6360,490,6240,490,6120,490C6000,490,5880,490,5760,490C5640,490,5520,490,5400,490C5280,490,5160,490,5040,490C4920,490,4800,490,4680,490C4560,490,4440,490,4320,490C4200,490,4080,490,3960,490C3840,490,3720,490,3600,490C3480,490,3360,490,3240,490C3120,490,3000,490,2880,490C2760,490,2640,490,2520,490C2400,490,2280,490,2160,490C2040,490,1920,490,1800,490C1680,490,1560,490,1440,490C1320,490,1200,490,1080,490C960,490,840,490,720,490C600,490,480,490,360,490C240,490,120,490,60,490L0,490Z"
            ></path>
          </svg> */}
          <img
            src={bglogin}
            className="w-full h-full object-cover object-center blur-sm contrast-75"
          />
        </div>

        {!otpStatus && (
          <ZoomTransition>
            <div className="input-field-box">
              <EmaillSentInput />
            </div>
          </ZoomTransition>
        )}
        {otpStatus && (
          <ZoomTransition>
            <div className="input-field-box">
              <OtpValidationInput />
            </div>
          </ZoomTransition>
        )}
      </div>
    </div>
  );
};

export default EmailVerify;
